const syntheticGraphiteData = {
  hero: 'https://res.cloudinary.com/benchmarkminerals/image/upload/v1732133790/assets/data-reports/price-assessments/benchmarkminerals_Graphs_and_charts_photorealistic_realistic_sh_8de067f0-a10d-4781-b329-2742dd547a2c_drhuhb.png',
  priceAssessmentsBrochureFile: {
    category: 'methodology-price-assessments',
    file_name: 'Benchmark-Synthetic-Graphite-Price-Assessment-Methodology.pdf',
    EnvKey: 'syntheticGraphitePriceAssessmentsMethodologyId',
  },
  forecastBrochureFile: {
    EnvKey: 'forecastBrochureSyntheticGraphiteFilePdfID',
    file_name: 'Synthetic Graphite Forecast Brochure.pdf',
    category: 'public-documents',
  },
  esgBrochureFile: {
    file_name: 'Graphite ESG Report Brochure - Benchmark.pdf',
    category: 'public-documents',
    EnvKey: 'ESGBrochureGraphiteFilePdfId',
  },
  banner: {
    title:
      'Our service includes a deep-dive on each link in the natural graphite supply chain including:',
    descriptions: [
      {
        items: [
          '<strong>Mine by Mine:</strong> Natural Graphite Concentrate',
          '<strong>Plant by Plant:</strong> Spherical Graphite',
          '<strong>Battery Focus:</strong> Demand by Anode Chemistry with market share & intensity numbers',
          '<strong>Battery Demand:</strong> Scenarios of EV, Stationary and Portable Tech',
          '<strong>Industrial vs Battery:</strong> Market-Specific Consumption Data',
        ],
      },
    ],
    images: {
      one: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1719430762/assets/market/synthetic-graphite/syntetic-graphite-1_ihzh2p.jpg',
        alt: 'Natural Graphite Forecasts',
      },
      two: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1719430762/assets/market/synthetic-graphite/syntetic-graphite-2_r5exwk.jpg',
        alt: 'Natural Graphite Forecasts',
      },
      three: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1719430762/assets/market/synthetic-graphite/syntetic-graphite-3_s4xeee.jpg',
        alt: 'Natural Graphite Forecasts',
      },
    },
  },
  sections: {
    one: {
      image:
        'https://res.cloudinary.com/benchmarkminerals/image/upload/c_fill,g_auto,f_auto,q_auto,h_700/v1719430760/assets/market/synthetic-graphite/syntetic-graphite-4_yzdigw.jpg',
      title:
        'Review how battery costs vary between technologies, manufacturing scale, and raw material inputs:',
      descriptions: [
        {
          subtitle:
            'Our full picture understanding of natural graphite is most prevalent in our bottom-up cost curve analysis.',
          items: [
            '<strong>Cost breakdown:</strong> analysis of the cost structure for battery cells across different chemistries',
            '<strong>Bill of materials:</strong> monitor the impact of material costs',
            '<strong>A fully customisable</strong> battery cost model profiling costs across different plants, regions and technology profiles',
          ],
        },
        {
          subtitle:
            'We present a "Total Cost" number for each operating mine and development project under review which also considers:',
          items: [
            '<strong>Cash/Opex</strong>, Capital Charge & Taxes & Royalties.',
            '<strong>Time Travel:</strong> Compare Cost Curves between 2019, 2020 & 2030',
            '<strong>Plan for your future contracts</strong>, inventory or investment needs',
          ],
        },
      ],
    },
    two: {
      image:
        'https://res.cloudinary.com/benchmarkminerals/image/upload/c_fill,g_auto,f_auto,q_auto,h_700/v1719430761/assets/market/synthetic-graphite/syntetic-graphite-5_oj1rui.jpg',
      title:
        'You will receive full, unrestricted access to the data behind Benchmark’s Natural Graphite Forecast service.',
      descriptions: [
        {
          items: [
            '<strong>Online</strong> accessible downloads each quarter',
            '<strong>Clear & Concise:</strong> Your data is presented in 3 Excel Files - Natural Graphite Forecast, Natural Graphite Price Forecast & Natural Graphite Total Cost Model',
            '<strong>Implement Your Ideas</strong>: Each file is fully editable so you can input your own assumptions',
          ],
        },
      ],
    },
  },
}
export default syntheticGraphiteData
